import { Injectable } from '@angular/core';
import { DisplayFSE } from '../../beneficiaries/beneficiary-folder/fse/displayFSE';
import { SurveyFSEDto } from '../../beneficiaries/beneficiary-folder/fse/surveyFSEDto';
import { environment } from '../../environments/environment';
import { Pagination } from '../pagination/pagination';
import { PaginationOptions } from '../pagination/pagination-options';
import { ApiService } from './api.service';
import { Subject, Observable } from 'rxjs';
import { SurveyFSESaveDto } from '../../beneficiaries/beneficiary-folder/fse/fse-details/surveyFseSave.dto';

@Injectable({
  providedIn: 'root',
})
export class SurveysFSEService {
  public surveySave: Subject<SurveyFSESaveDto> = new Subject<SurveyFSESaveDto>();
  public surveySaved$: Observable<SurveyFSESaveDto> = this.surveySave.asObservable();

  constructor(private readonly api: ApiService) {}

  public async findByBeneficiaryId(id: number, options: PaginationOptions): Promise<Pagination<DisplayFSE>> {
    const uri: string = environment.api.surveysFSE + '/' + id;
    return this.api.getPaginated<DisplayFSE>(options.buildUrl(uri));
  }

  public async findBySurveyId(idSurveyFSE: number): Promise<SurveyFSEDto | undefined> {
    const uri: string = environment.api.surveysFSE + '/' + idSurveyFSE + '/details';
    const result: SurveyFSEDto = await this.api.get<SurveyFSEDto>(uri);
    if (result) {
      return SurveyFSEDto.fromJson(result);
    }
  }

  public async saveSurveFse(survey: SurveyFSESaveDto, accessMode: string): Promise<void> {
    await this.api.post<void, SurveyFSESaveDto>(environment.api.surveysFSE + `/${accessMode ? '?accessMode=' + accessMode : ''}`, survey);
    this.surveySave.next(survey);
  }

  public async delete(id: number): Promise<void> {
    await this.api.delete(environment.api.surveysFSE + '/' + id);
    this.surveySave.next(undefined);
  }
}
